<template>
  <div class="policeEnd" style="height:270px;">
    <div class="endFire">
      <img src="~@/assets/img/endFire.png" alt/>
    </div>
    <div class="end-title" style="height:auto;margin-bottom:10px;width:70%;margin-left:30%;text-align:left">
      <!-- <span>任务已结束，请总结</span> -->
      <div><span style="color:#0a5a93;line-height:35px"></span>出警人：{{jssdLs.popUpWay}}</div>
      <div><span style="color:#0a5a93;line-height:35px"></span>报警时间：{{jssdLs.alarmTime}}</div>
      <div><span style="color:#0a5a93;line-height:35px"></span>地址：{{jssdLs.detail}}</div>
    </div>
    <!-- <div class="endRe">
      <el-button @click="summary" class="end-btn" round type="primary">
        <span>结束总结</span>
      </el-button>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props:{
    jssdLs:{
      required:true
    }
  },
  created(){
    let _this = this;
    setTimeout(function(){
      _this.$emit("closePoliceEnd");
      _this.bus.$emit('closeDialog');
      _this.$router.push("/home");
    },5000)
    
  },
  methods: {

    // summary() {
    //   let _this = this;
    //   _this.$emit("closePoliceEnd");
    //   _this.$emit("openReview");
    //   _this.bus.$emit('closeDialog')
    //   // _this.$router.push("/home");
    // },
  },
};
</script>
<style lang="less" scoped>
.policeEnd {
  text-align: center;

  .endFire {
    margin: 10px 0 10px 0;
    img{
      display:block;
      margin:0 auto 25px;
      width:130px;
    }
  }
  .endRe {
    margin-top: 73px;
    cursor: pointer;
  }
}

.end-title {
  height: 25px;
  text-align: center;
  line-height: 25px;

  span {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }
}

.end-btn {
  width: 206px;
  height: 43px;
  background: #0080db;
  border-radius: 8px;

  span {
    font-size: 18px;
    font-weight: bold;
    color: #ffffff
  }
}
</style>



// WEBPACK FOOTER //
// src/components/policeEnd.vue